<template>
    <tr :class="{'disabled':isSubmitting}">
        <td>
            <button :disabled="isSubmitting" @click="onDelete" class="btn btn-sm btn-danger"><i class="fa fa-trash"></i>Delete
            </button>
        </td>
        <td>{{moduleRole.moduleName}}</td>
        <td>{{moduleRole.moduleRoleName}}</td>
        <td>{{moduleRole.organizationRoleName}}</td>
        <td class="text-center">
            <AppCheckBox :disabled="isSubmitting" @click="onUpdate" v-model="moduleRole.grantMyStuffAccess"/>
        </td>
    </tr>
</template>

<script>
    import AppCheckBox from "@/components/shared/AppCheckBox";
    import OracleService from "@/services/OracleService";
    import {ToastType} from "@/services/models/shared/ToastType";

    export default {
        components: {
            AppCheckBox
        },
        data() {
            return {
                isSubmitting: false
            }
        },
        props: {
            moduleRole: {
                type: Object,
                required: true
            }
        },
        methods: {
            /**
             * @description Emits the delete event to the parent component
             */
            onDelete() {
                const vm = this;

                this.$emit('delete',
                    vm.moduleRole,
                )
            },

            /**
             * @description Updates the role and posts the event to the parent component
             */
            onUpdate() {
                const vm = this;

                // Toggle the value
                this.moduleRole.grantMyStuffAccess = !this.moduleRole.grantMyStuffAccess;

                vm.isSubmitting = true;
                OracleService.updateAccountModuleRole(this.moduleRole.accountId, this.moduleRole).then(() => {
                    vm.alert(ToastType.Success, `The ${vm.moduleRole.moduleRoleName} role was successfully updated.`)
                }).catch(error => {
                    vm.alert(ToastType.Danger, error.response.statusText);
                }).finally(() => {
                    vm.isSubmitting = false;

                    // Emit the event to the parent
                    vm.$emit('update', vm.moduleRole);
                });
            }
        }
    }
</script>
